module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img_medium.ea53e989.jpg";